import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../../data.service';
import { GeneralService } from '../../../../general.service';
import {TranslateService} from '@ngx-translate/core';
import { SSL_OP_NETSCAPE_CHALLENGE_BUG } from 'constants';
import { Subscription } from 'rxjs';

declare var decimalInput: any;

@Component({
  selector: 'app-matrix',
  templateUrl: './matrix.html',
  styleUrls: ['./matrix.scss']
})

export class Matrix implements OnInit {

  public showDecimalInput = false;
  public isTouchDevice = false;
  public isInTask = false;
  public answers = [];
  public headers = [];
  public rows = [];
  public rowsArr = [];

  private loadAnswersSubscription : Subscription;
  
  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService
  ) { 
    var exisitingLangauge = localStorage.getItem("userslanguage");
    if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
      this.dataSvc.changeLangauge(exisitingLangauge);
    }
    else{
      this.translate.setDefaultLang("en");
      this.translate.use("en");
    }

    this.loadAnswersSubscription = this.dataSvc.getLoadMatrixLabelAnswersEvent().subscribe(()=>{
      this.loadAnswers();
    });
  }

  ngOnInit(): void {
    this.loadAnswers();
  }

  resetVariables(){
    this.answers = [];
    this.headers = [];
    this.rows = [];
    this.rowsArr = [];
  }

  loadAnswers() {
    this.resetVariables();
    if(this.dataSvc.currentQuestion().Question.QuestionType !== 11) return;
    this.rows = [];
    var currentQuestion = this.dataSvc.currentQuestion();
    var headers = currentQuestion.Question.Question.Responses[0].Headings;
    var matrix = Object.keys(currentQuestion.Question.Question.Responses[0].Matrix).filter(k => k !== '$id');

    this.headers = headers;
    this.rows = matrix;

    setTimeout(() => {
      this.loadSavedAnswers();
    },100);

    // var response = currentQuestion.QuestionResponses[0].Response;
    // if(response !== null && response !== undefined){
    //   this.rowsArr = response.AnswerText.split("\r\n");
    //   for(var i = 0; i < this.rowsArr.length; i++){
    //     if(this.rowsArr[i] !== null && this.rowsArr[i] !== undefined && 
    //       /\S/.test(this.rowsArr[i])){
    //         if(this.rowsArr[i].indexOf(",") > -1){
    //           this.rowsArr[i] = this.rowsArr[i].replace(",", "");
    //         }
    //         this.rows.push(this.rowsArr[i]);
    //       }
    //   }
    //   this.headers = response.QuestionText.split(",");
    //   setTimeout(() => {
    //     this.loadSavedAnswers();
    //   },100);
      
    // }
  }

  loadSavedAnswers(){
    var savedAns = this.dataSvc.currentQuestion().Result.Selection;
    if(savedAns !== ""){
      this.answers = savedAns.split(",");
      for(var i = 0; i < this.answers.length; i++){
         var answer = this.answers[i].split(":");
         if(answer !== null && answer !== undefined){
           var elements = document.querySelectorAll("[data-rowindex='" + (parseInt(answer[0]) - 1) + "']");
           for(var e = 0; e < elements.length; e++){
            var element = (<HTMLInputElement>elements[e]);
            if(element !== null && element !== undefined){
              var header = parseInt(element.getAttribute("data-headerindex"));
              if((parseInt(answer[1]) - 1) === header){
                element.checked = true;
              }
            }
           }
         }
      }
    }
  }


  updateResponse(event){
    var element = event.target;
    var row = parseInt((<HTMLInputElement>element).getAttribute("data-rowindex"));
    var header = parseInt((<HTMLInputElement>element).getAttribute("data-headerindex"));

    var answer = (row + 1) +":" + (header + 1);
    var index = this.answers.findIndex(element => element.includes((row + 1) +":"))
    if(index == -1)
    {
      this.answers.push(answer);
    }
    else{
      this.answers.splice(index);
       this.answers.push(answer);
    }
    this.dataSvc.currentQuestion().Result.Selection = this.answers.join(",");
  } 
}
